// GO GIFT CARD BUTTON

document.addEventListener('DOMContentLoaded', function () {
  const productId = '9276913221863'; 

  function removeDuplicateGiftButtons() {
    const form = document.querySelector('#custom-add-to-cart-form');
    if (!form) return;

    const buttons = form.querySelectorAll('button.ggc-button-1');
    if (buttons.length > 1) {
      for (let i = 1; i < buttons.length; i++) {
        buttons[i].remove();
      }
    }
  }

  function reloadSendAsGiftButton(productId) {
    const existing = document.querySelector('go-gift-cards');
    if (existing) existing.remove();

    const form = document.querySelector('#custom-add-to-cart-form');
    if (!form) return;

    const giftCardEl = document.createElement('go-gift-cards');
    giftCardEl.dataset.productId = productId;

    form.appendChild(giftCardEl);
    setTimeout(removeDuplicateGiftButtons, 100);
  }
  reloadSendAsGiftButton(productId);
  document.addEventListener('variant:change', function () {
    setTimeout(() => {
      reloadSendAsGiftButton(productId);
    }, 200);
  });

  const formContainer = document.querySelector('#custom-add-to-cart-form');
  if (formContainer) {
    const observer = new MutationObserver(() => {
      const giftBtn = document.querySelector('go-gift-cards');
      if (!giftBtn) {
        reloadSendAsGiftButton(productId);
      } else {
        removeDuplicateGiftButtons();
      }
    });

    observer.observe(formContainer, {
      childList: true,
      subtree: true
    });
  }
});